var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    {
      staticClass: "overflow-hidden fill-height",
      staticStyle: { position: "relative", "border-radius": "0 !important" },
    },
    [
      _c(
        "v-btn",
        {
          staticClass: "menu-btn",
          attrs: { dark: "", small: "" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              _vm.drawer = !_vm.drawer
            },
          },
        },
        [_c("v-icon", [_vm._v(_vm._s(_vm.icons.menu))])],
        1
      ),
      _c(
        "div",
        {
          staticClass: "fill-height",
          on: {
            click: function ($event) {
              _vm.drawer = false
            },
          },
        },
        [_vm._t("default")],
        2
      ),
      _c(
        "v-navigation-drawer",
        {
          staticStyle: { "z-index": "5" },
          attrs: { fixed: "", dark: "" },
          model: {
            value: _vm.drawer,
            callback: function ($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer",
          },
        },
        [
          _c(
            "v-container",
            { staticClass: "py-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { justify: "center", align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "pa-1", attrs: { cols: "10" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "pa-1 white--text text-none font-weight-black",
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.goTo({ to: "main" })
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "shop-name" }, [
                            _vm._v(_vm._s(_vm.shop.name)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-center pa-1",
                      staticStyle: { cursor: "pointer" },
                      attrs: { cols: "2" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.drawer = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icons.close))])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-list",
            { staticClass: "pt-0 mb-12 px-4", attrs: { dense: "", nav: "" } },
            [
              _vm.has_perm("renew_site")
                ? _c(
                    "v-container",
                    { staticClass: "py-0", attrs: { fluid: "" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "text-center" },
                            [
                              _vm.subscription_ending_date > _vm.date_now
                                ? _c(
                                    "v-chip",
                                    {
                                      attrs: { small: "", color: "success" },
                                      on: { click: _vm.showRenewSubscription },
                                    },
                                    [
                                      _vm._v(
                                        "Активен до " +
                                          _vm._s(
                                            _vm.str_subscription_ending_date
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "v-chip",
                                    {
                                      attrs: { small: "", color: "error" },
                                      on: { click: _vm.showEndSubscription },
                                    },
                                    [_vm._v("Сайт не активен")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.shop.owner === _vm.client.user.id
                ? _c("v-divider")
                : _vm._e(),
              _c(
                "v-container",
                { staticClass: "py-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center", justify: "center" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pl-0 pr-2 text-center",
                          attrs: { cols: "3" },
                        },
                        [
                          _c(
                            "v-avatar",
                            { attrs: { height: "50", width: "50" } },
                            [
                              _c("img", {
                                attrs: {
                                  src: "https://icons.iconarchive.com/icons/papirus-team/papirus-status/512/avatar-default-icon.png",
                                  alt: "Profile",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pl-1 pr-0 body-2 font-regular",
                          attrs: { cols: "7" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("truncate")(
                                  _vm.client.user.first_name,
                                  12
                                )
                              ) +
                              " " +
                              _vm._s(
                                _vm._f("truncate")(
                                  _vm.client.user.last_name,
                                  12
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "text-center pa-1",
                          attrs: { cols: "2" },
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { right: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticStyle: {
                                              color: "rgb(128,128,128)",
                                            },
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.logout.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v(_vm._s(_vm.icons.exit)),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_c("span", [_vm._v("Выход из аккаунта")])]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "mb-4" }),
              _c(
                "v-container",
                {
                  staticClass: "py-1 secondary lighten-1",
                  staticStyle: { "border-radius": "5px" },
                  attrs: { fluid: "" },
                },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center", justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-0 pr-0", attrs: { cols: "5" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "caption",
                              staticStyle: { color: "#9b9b9b" },
                            },
                            [_vm._v("Баланс")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "body-2 font-weight-regular text-no-wrap",
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.client.balance) + " "),
                              _c(
                                "v-icon",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    bottom: "1px",
                                    right: "2.5px",
                                  },
                                  attrs: { size: "15" },
                                },
                                [_vm._v(_vm._s(_vm.icons.rub) + " ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0",
                          staticStyle: { "padding-right": "6px" },
                          attrs: { cols: "7" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "text-none body-2 font-weight-regular",
                              attrs: {
                                dark: "",
                                depressed: "",
                                block: "",
                                color: "green",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onPayment(false)
                                },
                              },
                            },
                            [_vm._v(" Пополнить ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass:
                    "mt-1 mb-4 text-none caption font-weight-regular",
                  attrs: {
                    small: "",
                    text: "",
                    block: "",
                    disabled: _vm.client.balance <= 0,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onPayment(true)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticStyle: { position: "absolute", left: "-9px" },
                      attrs: { size: "19", color: "green" },
                    },
                    [_vm._v(_vm._s(_vm.icons.return))]
                  ),
                  _vm._v(" Возврат денежных средств "),
                ],
                1
              ),
              _c("v-divider"),
              _vm._l(_vm.items, function (item) {
                return _c(
                  "v-list-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.show,
                        expression: "item.show",
                      },
                    ],
                    key: item.title,
                    staticClass: "my-2",
                    attrs: {
                      to: { name: item.to, params: item.params },
                      link: "",
                    },
                  },
                  [
                    _c(
                      "v-list-item-icon",
                      { staticClass: "mr-3" },
                      [
                        _c("v-icon", { attrs: { size: "22" } }, [
                          _vm._v(_vm._s(item.icon)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "v-list-item-content",
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "body-2 font-weight-regular" },
                          [_vm._v(" " + _vm._s(item.title) + " ")]
                        ),
                      ],
                      1
                    ),
                    item.count !== undefined && item.count !== 0
                      ? _c(
                          "v-list-item-action",
                          { staticClass: "pt-3" },
                          [
                            _c("v-badge", {
                              attrs: {
                                color: "warning",
                                content: `${item.count}`,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm.shop.access_token
                ? _c(
                    "v-list-item",
                    [
                      _c(
                        "v-container",
                        { staticClass: "pa-0", attrs: { fluid: "" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "pa-0",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-0",
                                  staticStyle: { "max-width": "189px" },
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("vk-allow-messages", {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      "margin-left": "auto",
                                    },
                                    attrs: {
                                      height: 30,
                                      "group-id": parseInt(
                                        _vm.shop.vk_group_id
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "v-footer",
            {
              staticClass: "pa-0",
              staticStyle: { "border-top": "1px solid #4e4e4e" },
              attrs: { absolute: "" },
            },
            [
              _vm.shop.owner === _vm.client.user.id
                ? _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                href: "https://vk.me/posredpro",
                                target: "_blank",
                                depressed: "",
                                small: "",
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-face-agent"),
                              ]),
                              _vm._v(" Нужна помощь? "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("payment-dialog"),
      _c("end-subscription-dialog"),
      _c("publication-dialog"),
      _c("search-subscription-dialog"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }